interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  return (
    <div
      className={`mobile-menu ${isOpen ? 'open' : ''}`}
      id="mobile-menu"
      aria-hidden={!isOpen}
    >
      <div className="mm-top">
        <img src={`${process.env.PUBLIC_URL}/assets/logo-praksi.png`} alt="Φροντιστήριο Πράξη" />
        <button
          className="mm-close"
          id="mm-close"
          aria-label="Κλείσιμο μενού"
          onClick={onClose}
        >
          ×
        </button>
      </div>
      <nav>
        <a href="#about" onClick={onClose}>Το φροντιστήριό μας</a>
        <a href="#why" onClick={onClose}>Γιατί Πράξη</a>
        <a href="#stats" onClick={onClose}>Επιτυχίες</a>
        <a href="#orient" onClick={onClose}>Επαγγελματικός προσανατολισμός</a>
        <a href="#contact" onClick={onClose}>Επικοινωνία</a>
      </nav>
      <div className="mm-cta">
        <a className="btn btn-red" href="tel:+302251054070">Καλέστε μας · 22510 54070</a>
        <a className="btn btn-outline" href="#contact" onClick={onClose}>Κλείστε ραντεβού</a>
      </div>
    </div>
  );
}
